<template>
  <div class="w-full h-full">
    <div
      v-for="(item, index) in catalogue.list"
      :key="index"
    >
      <!-- 章节 -->
      <div
        v-if="catalogue.type"
        class="mt-16"
        :class="[index === 0 ? 'mt-15' : 'mt-0']"
        @click="clickCatalogue(item)"
      >
        <div
          class="flex justify-between items-center space-x-15"
        >
          <div>
            <div class="text-18 font-bold line-height-22 line-2">
              {{ item.title }}
            </div>
            <div class="text-gray text-10 line-height-22">
              {{ `已更新 ${item.list.length} 期` }}
            </div>
          </div>
          <van-icon name="arrow" color="#9C9C9C" />
        </div>
        <van-divider
          style="margin-bottom: 0 !important;"
        />
      </div>
      <!-- 课程列表 -->
      <template
        v-if="item.state === 'expand' || !catalogue.type"
      >
        <van-cell-group
          v-for="(courseItem, index) in item.list"
          :key="index"
          :border="false"
          class="cursor-pointer border-gray-F1F4F8 py-16 !mx-0 !bg-transparent catalogue-item"
          @click="startStudy(courseItem)"
        >
          <tk-flex middle :gutter="14">
            <div class="text-18 font-bold line-height-22 line-2">
              {{ courseItem.name }}
            </div>
          </tk-flex>
          <tk-flex
            middle
            between
            v-if="isRecordProgress"
          >
            <tk-flex
              middle
              :gutter="3"
              class="mt-5 text-10 text-gray flex-grow-1"
            >
              <div>
                {{ `${courseItem.count}次学习` }}
              </div>
              <div>
                |
              </div>
              <div>
                {{ `已学${courseItem.percent}%` }}
              </div>
            </tk-flex>
            <van-tag
              v-if="watchUrlRecord === courseItem.vcode"
              class="mt-2 h-16 flex-shrink-0 overflow-hidden rounded-4"
              color="#F8604E"
            >
              <div class="text-8 text-white">
                上次看到
              </div>
            </van-tag>
          </tk-flex>
        </van-cell-group>
      </template>
      <!-- 展开/收起 -->
      <div
        v-if="catalogue.type"
        @click.stop="toggle(index, item)"
        class="flex items-center justify-center py-12 space-x-6"
      >
        <div class="text-10 text-gray">
          {{ item.state === 'expand' ? '收起' : '展开' }}
        </div>
        <van-icon
          :name="item.state === 'expand' ? 'arrow-up' : 'arrow-down'"
          color="#9C9C9C"
          size="12"
        />
      </div>
      <!-- 篇章间分隔线 -->
      <div
        v-if="catalogue.type && index < catalogue.list.length - 1"
        class="w-full h-1"
        style="background-color: #9C9C9C;"
      />
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { mapState } from 'vuex'
export default {
  props: {
    courseId: {
      type: String,
      default: '',
    },
    catalogue: {
      type: Object,
      default: () => {
        return {
          type: false,
          list: []
        }
      },
    },
    name: {
      type: String,
      default: '',
    },
    watchUrlRecord: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState({
      user: state => state.user,
      isRecordProgress: state => state.isRecordProgress,
    }),
  },
  created () {
    if (!this.catalogue.list.length) {
      return
    }
    this.catalogue.list.forEach((s) => { s.state = 'close' }) // expand close
  },
  methods: {
    // | 展开收起
    toggle (index, item) {
      this.catalogue.list[index].state = item.state === 'expand' ? 'close' : 'expand'
      this.$forceUpdate()
    },
    // | 点击目录
    clickCatalogue (item) {
      if (!item.list.length) {
        Toast({
          message: '该目录暂无课程',
          position: 'bottom',
        })
        return
      }
      this.$push({
        path: '/course/startStudy',
        query: {
          id: this.courseId,
          vcode: item.list[0].vcode,
        },
      })
    },
    // | 点击课程开始学习
    startStudy (courseItem) {
      this.$push({
        path: '/course/startStudy',
        query: {
          id: this.courseId,
          vcode: courseItem.vcode,
        },
      })
    }
  },
}
</script>

<style scoped lang="scss">
.catalogue-item {
  border-bottom: 1px solid #e5e5e5;
  padding-left: 15px;
  padding-right: 15px;
}
</style>
